import React, { useEffect } from "react";
import { PrintList } from "./PrintList";
import { useDispatch } from "react-redux";
import { getFalsePrintFileFetch } from "../../features/action/fetchPrint";

const DesignerPrint = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFalsePrintFileFetch());
  }, [dispatch]);
  return <PrintList />;
};

export default DesignerPrint;
